import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionHelper } from '@src/app/helpers/sessionHelper';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-baseroute',
  templateUrl: './baseroute.component.html',
  styleUrls: ['./baseroute.component.css']
})
export class BaserouteComponent implements OnInit {

  constructor(
    private router:Router
  ) { }

  ngOnInit() {

    this.router.navigate(['/person/'+SessionHelper.getUserSub()]);
  }

}
